import React from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import * as yup from "yup";
import { useState } from "react";
import {
  saveIncomingInvoice,
  getIncomingInvoiceDetail,
} from "../../../../services/finance/incomingInvoice";
import { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import Swal from "sweetalert2";
import IncomingInvoiceItem from "./incomingInvoiceItem";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import AppForm from "../../../../partials/content/Forms/AppForm";
import IncomingInvoiceHeader from "./incomingInvoiceHeader";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import { sendApprovalRequests, setObject } from "../../../../utils/utils";
import { DateTime } from "luxon";

const incomingInvoiceSchema = yup.object().shape({
  ID: yup.number(),
  vendorInvoiceNo: yup
    .string()
    .max(255, "Vendor Invoice Number maximum characters is 255"),
  invoiceType: yup.string(),
  purchaseOrderID: yup.number(),
  vendorID: yup.number(),
  vendorName: yup.string().required("Vendor Name is required"),
  invoiceDate: yup
    .date()
    .required("Invoice Date is required")
    .max(
      yup.ref("deadlineDate"),
      "Invoice Date must be less equal to Deadline Date"
    ),
  deadlineDate: yup
    .date()
    .required("Deadline Date is required")
    .min(
      yup.ref("invoiceDate"),
      "Deadline Date must be greater equal to Invoice Date"
    ),
  currencyID: yup.number(),
  currencyCode: yup.string(),
  vendorBankAccount: yup.string(),
  subTotalAmount: yup.number(),
  discountAmount: yup.number(),
  taxAmount: yup.number(),
  grandTotal: yup.number(),
  address: yup
    .string()
    .required("Address is required")
    .max(255, "Address maximum characters is 255"),
  city: yup
    .string()
    .required("City is required")
    .max(50, "City maximum characters is 50"),
  addressPhone: yup
    .string()
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  addressEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  province: yup.string().max(50, "Province maximum characters is 50"),
  countryCode: yup.string(),
  postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
  contactName: yup
    .string()
    .required("Contact Name is required")
    .max(255, "Contact Name maximum characters is 255"),
  position: yup.string().max(50, "Position maximum characters is 50"),
  contactPhone: yup
    .string()
    .required("Phone Number is required")
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  contactEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  note: yup.string(),
  toc: yup.string(),
  recStartDate: yup.date(),
  recIssueDate: yup
    .number()
    .max(31, "Date Max is 31")
    .min(1, "Date min is 1"),
  recDeadlineDate: yup
    .number()
    .max(31, "Date Max is 31")
    .min(1, "Date min is 1"),
  recEvery: yup.number(),
  periodType: yup.string(),
  invoiceItem: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        purchaseOrderItemID: yup.number(),
        itemID: yup.number(),
        itemName: yup.string().required("Item is Required"),
        varCode: yup.string(),
        qty: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Quantity is required")
          .moreThan(0, "Quantity cannot be zero or empty")
          .when(["purchaseOrderItemID", "ID"], {
            is: (purchaseOrderItemID, ID) =>
              purchaseOrderItemID > 0 && ID === 0,
            then: yup
              .number()
              .max(
                yup.ref("qtyLeft"),
                "Total Quantity cannot be more than Purchase Order Item Quantity"
              ),
          })
          .default(0),
        qtyLeft: yup.number(),
        uomID: yup.number(),
        uomName: yup.string().required("Unit is required"),
        unitPrice: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Unit Price is required")
          .moreThan(0, "Unit Price cannot be zero or empty")
          .default(0),
        discountPercent: yup.number().default(0),
        discountAmount: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .default(0),
        taxPercent: yup.number().default(0),
        taxAmount: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .default(0),
        totalPrice: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Total Price is required")
          .default(0),
        accountName: yup.string().when("poItem", {
          is: (value) => value === false,
          then: yup.string().required("Expense Account is required"),
        }),
        poItem: yup.bool(),
      })
    )
    .required("Invoice Items is required"),
  additionalCost: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      itemName: yup.string().required("Cost Name is Required"),
      accountName: yup.string().required("Account is required"),
      costPrice: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Cost Price is required")
        .moreThan(0, "Cost Price cannot be zero or empty")
        .default(0),
    })
  ),
});

function IncomingInvoiceForm({ history, match }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const { companyProfile, socket } = useGlobalData();
  const { auth } = store.getState();
  const { fullName } = auth.user;
  const [incomingInvoice, setIncomingInvoice] = useState({
    ID: 0,
    incomingInvoiceCode: "",
    docRef: "1",
    docRefDesc: "",
    invoiceType: "1",
    grStatus: 1,
    grStatusDesc: "",
    paymentStatus: 1,
    paymentStatusDesc: "",
    purchaseOrderID: 0,
    purchaseOrderCode: "",
    vendorID: 0,
    vendorName: "",
    vendBankAccountID: 0,
    vendBankAccountDesc: "",
    vendorInvoiceNo: "",
    invoiceDate: DateTime.now().startOf("day"),
    deadlineDate: DateTime.now()
      .endOf("day")
      .plus({ days: 14 }),
    addressName: {},
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    contact: {},
    contactName: "",
    position: "",
    contactPhone: "",
    contactEmail: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    subTotal: 0,
    discountPercent: 0,
    discountAmount: 0,
    taxPercent: 0,
    taxAmount: 0,
    exchangeRate: 1,
    grandTotal: 0,
    addCostTotal: 0,
    note: "",
    toc: "",
    recStartDate: DateTime.now().startOf("day"),
    recIssueDate: 1,
    recDeadlineDate: 1,
    recEvery: 1,
    periodType: "M",
    invoiceItem: [],
    additionalCost: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });

  const invoiceID = match.params.invoiceID;
  useEffect(() => {
    const { auth } = store.getState();

    async function getIncomingInvoiceDetailData(invoiceID) {
      if (typeof invoiceID !== "undefined") {
        const invoiceItemRec = [];
        const response = await getIncomingInvoiceDetail(invoiceID);
        const { data } = response.data;
        const incomingInvoice = data.incomingInvoice;
        incomingInvoice.incomingInvoiceItem.forEach((item) => {
          invoiceItemRec.push({
            ID: item.ID,
            itemType: item.item.itemType,
            purchaseOrderItemID: item.purchaseOrderItemID,
            itemID: item.itemID,
            itemType: item.itemType,
            itemTypeName: item.itemTypeName,
            itemCode: item.itemCode,
            itemName: item.itemName,
            varCode: item.varCode,
            qty: item.qty,
            qtyLeft: item.qtyLeft,
            uomID: item.uomID,
            uomName: item.uom.uomName,
            unitPrice: item.unitPrice,
            taxPercent: item.taxPercent,
            taxAmount: item.taxAmount,
            discountAmountType: 1,
            discountPercent: item.discountPercent,
            discountAmount: item.discountAmount,
            totalPrice: item.totalPrice,
            expenseAccountID: item.expenseAccountID,
            accountName: item.expenseAccount.accountName,
            poItem: item.purchaseOrderItemID > 0 ? true : false,
            unRegItem: item.ID > 0 ? false : true,
            deleteInd: false,
          });
        });
        setIncomingInvoice({
          ID: incomingInvoice.ID,
          incomingInvoiceCode: incomingInvoice.incomingInvoiceCode,
          docRef: incomingInvoice.docRef,
          docRefDesc:
            incomingInvoice.purchaseOrderID > 0 ? "Purchase Order" : "",
          invoiceType: "1",
          grStatus: incomingInvoice.grStatus,
          grStatusDesc: incomingInvoice.grStatusDesc,
          paymentStatus: incomingInvoice.paymentStatus,
          paymentStatusDesc: incomingInvoice.paymentStatusDesc,
          purchaseOrderID: incomingInvoice.purchaseOrderID,
          purchaseOrderCode: incomingInvoice.purchaseOrderCode,
          vendorID: incomingInvoice.vendorID,
          vendorName: incomingInvoice.vendor.vendorName,
          vendBankAccountID: incomingInvoice.vendBankAccountID,
          vendBankAccountDesc: incomingInvoice.vendBankAccountDesc,
          vendorInvoiceNo: incomingInvoice.vendorInvoiceNo,
          invoiceDate: incomingInvoice.invoiceDate,
          deadlineDate: incomingInvoice.deadlineDate,

          address: incomingInvoice.address,
          city: incomingInvoice.city,
          province: incomingInvoice.province,
          countryCode: incomingInvoice.countryCode,
          postalCode: incomingInvoice.postalCode,
          addressPhone: incomingInvoice.addressPhone,
          addressEmail: incomingInvoice.addressEmail,

          contactName: incomingInvoice.contactName,
          position: incomingInvoice.position,
          contactPhone: incomingInvoice.contactPhone,
          contactEmail: incomingInvoice.contactEmail,

          currencyID: incomingInvoice.currencyID,
          currencyCode: incomingInvoice.currency.currencyCode,
          subTotal: incomingInvoice.subTotal,
          discountPercent: incomingInvoice.discountPercent,
          discountAmount: incomingInvoice.discountAmount,
          taxPercent: incomingInvoice.taxPercent,
          taxAmount: incomingInvoice.taxAmount,
          addCostTotal: incomingInvoice.addCostTotal,
          exchangeRate: incomingInvoice.exchangeRate,
          grandTotal: incomingInvoice.grandTotal,
          note: incomingInvoice.note,
          toc: incomingInvoice.toc,
          recStartDate: incomingInvoice.recStartDate,
          recIssueDate: incomingInvoice.recIssueDate,
          recDeadlineDate: incomingInvoice.recDeadlineDate,
          recEvery: incomingInvoice.recEvery,
          periodType: incomingInvoice.periodType,
          invoiceItem: invoiceItemRec,
          additionalCost: incomingInvoice.additionalCost,
          CreatedAt: incomingInvoice.CreatedAt,
          UpdatedAt: incomingInvoice.UpdatedAt,
          createdBy: incomingInvoice.createdBy,
          updatedBy: incomingInvoice.updatedBy,
        });
      }
    }

    if (invoiceID > 0) {
      setObject(socket, "lock", invoiceID, "INVR", auth.user)
        .then((response) => {
          getIncomingInvoiceDetailData(invoiceID);
        })
        .catch((error) => {
          history.push("/finance/invoices/AP");
        });
    }
    return () => {
      if (invoiceID > 0) {
        setObject(socket, "release", invoiceID, "INVR", auth.user);
      }
    };
  }, [invoiceID]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Account Payable Invoice Form"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/invoices/AP",
            title: "A/P Invoices",
            active: false,
          },
          {
            page: "/finance/create-incoming-invoice",
            title: "A/P Invoice Form",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/invoices/AP");
            },
          },
        ]}
      />
      <AppForm
        initialValues={incomingInvoice}
        validationSchema={incomingInvoiceSchema}
        headSubmitButton
        onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
          values.subTotal = parseFloat(values.subTotal);
          values.discountAmount = parseFloat(values.discountAmount);
          values.taxAmount = parseFloat(values.taxAmount);
          values.grandTotal = parseFloat(values.grandTotal);
          values.invoiceItem.map((item) => {
            item.unitPrice = parseFloat(item.unitPrice);
            item.taxPercent = parseFloat(item.taxPercent);
            item.taxAmount = parseFloat(item.taxAmount);
            item.qty = parseFloat(item.qty);
            item.qtyLeft = parseFloat(item.qtyLeft);
            item.discountPercent = parseFloat(item.discountPercent);
            item.discountAmount = parseFloat(item.discountAmount);
            item.totalPrice = parseFloat(item.totalPrice);
          });

          values.additionalCost.forEach((item) => {
            item.costPrice = parseFloat(item.costPrice);
          });
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Account Payable Invoice ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveIncomingInvoice(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });

                  let toUsers = [];
                  const { data } = response.data;

                  if (
                    data.notificationToUsers &&
                    data.notificationToUsers.length > 0
                  ) {
                    data.notificationToUsers.map(
                      (notificationToUser, index) => {
                        toUsers.push({
                          ID: notificationToUser.toUserID,
                        });
                      }
                    );
                  }

                  if (toUsers && toUsers.length > 0) {
                    sendApprovalRequests(socket, fullName, toUsers);
                  }

                  history.push("/finance/invoices/AP");
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <ContentLayout>
          <IncomingInvoiceHeader />
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Account Payable Invoice Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <IncomingInvoiceItem property="invoiceItem" />
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
}

export default IncomingInvoiceForm;
